import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpParams,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { LoadingController, ToastController } from "ionic-angular";
import { Subject } from "rxjs";
import { Observable } from "rxjs/Observable";
import { forkJoin } from "rxjs/observable/forkJoin";
import { ConfigurationService } from "../configuration/configuration.service";
import { StateManagementService } from "../state-management/state-management.service";
/*
  Generated class for the PlanOfCareDataService provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PlanOfCareDataService {
  spinner = null;
  spinnerCounter = 0;
  private issueUpdatedSubject: Subject<any> = new Subject<any>();

  assessmentId: string;
  patChartId: string;
  dataUrl: string;
  apiUrl: string;
  // assessment_uuid: string;// = "3fdf9a79-8346-4c1e-8635-6fc8adc8180c"; //TODO fix retrieval
  addPocIssue: boolean = false;

  constructor(
    public http: HttpClient,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public stateData: StateManagementService,
    private config: ConfigurationService
  ) {
    this.dataUrl = config.getConfig().planOfCareUrl;
    this.apiUrl = config.getConfig().apiUrl;

    if (this.stateData.getChartId()) {
      this.patChartId = this.stateData.getChartId();
    } else {
      this.stateData.getChartIdObserver().subscribe((data) => {
        this.patChartId = data;
      });
    }

    if (this.stateData.getAssessmentId()) {
      this.assessmentId = this.stateData.getAssessmentId();
    } else {
      this.stateData.getAssessmentIdObserver().subscribe((data) => {
        this.assessmentId = data;
      });
    }

    // if( this.stateData.getAssessmentUuid() ) {
    //   this.assessment_uuid = this.stateData.getAssessmentUuid();
    // } else {
    //   this.stateData.getAssessmentUuidObserver().subscribe(
    //     data => {
    //       this.assessment_uuid = data;
    //     }
    //   )
    // }

    this.stateData.addPocIssue.subscribe((x) => {
      if (x !== null) {
        this.addPocIssue = x;
      }
    });
    // NOVA-1490: only persist if we have a real value. Previously used bracket
    // syntax which coerced undefined → the string "undefined" and bypassed any
    // setItem-based instrumentation.
    if (this.patChartId != null) {
      sessionStorage.setItem("patChartId", String(this.patChartId));
    }
  }

  setPatientChartId(patChartId: string) {
    // NOVA-1490: guard against undefined/null args so we never persist the
    // string "undefined" into sessionStorage.
    if (patChartId == null) {
      return;
    }
    this.patChartId = patChartId;
    sessionStorage.setItem("patChartId", String(this.patChartId));
  }

  setAssessmentId(assessmentId: string) {
    this.assessmentId = assessmentId;
  }

  ngOnDestroy() {
    console.log("leaving");
  }

  // GET CALLS
  // ----------------------------------

  getIssues(issueStatusType: string, patientChartId?: string) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    let params;
    if (+this.assessmentId) {
      params = new HttpParams()
        .set("issue_type", issueStatusType)
        .set("assessment_id", this.assessmentId)
        .set("add_poc_toggle", this.addPocIssue.toString());
    } else {
      params = new HttpParams()
        .set("issue_type", issueStatusType)
        .set("add_poc_toggle", this.addPocIssue.toString());
    }

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(
          `${this.dataUrl}/cp/patients/${
            patientChartId ? patientChartId : this.patChartId
          }/issues`,
          { headers: headers, params: params }
        )
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.get(`${this.dataUrl}/cp/patients/${this.patChartId}/issues`,
    //   { headers: headers, params: params });
  }

  getIssuesCount() {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    let params;
    if (+this.assessmentId) {
      params = new HttpParams().set("assessment_id", this.assessmentId);
    } else {
      params = new HttpParams();
    }

    //not returning; store values in session instead
    this.http
      .get(`${this.dataUrl}/cp/patients/${this.patChartId}/issue_count`, {
        headers: headers,
        params: params,
      })
      .subscribe(
        (data) => {
          let suggestedCount = data["issueCounts"].filter(
              (element) => element.lastStatusLookupValue === "Suggested"
            )[0],
            activeCount = data["issueCounts"].filter(
              (element) => element.lastStatusLookupValue === "Accepted"
            )[0],
            resolvedCount = data["issueCounts"].filter(
              (element) => element.lastStatusLookupValue === "Resolved"
            )[0],
            declinedCount = data["issueCounts"].filter(
              (element) => element.lastStatusLookupValue === "Declined"
            )[0];

          sessionStorage.setItem(
            "suggestedCount",
            suggestedCount ? suggestedCount.recordCount : 0
          );
          sessionStorage.setItem(
            "activeCount",
            activeCount ? activeCount.recordCount : 0
          );
          sessionStorage.setItem(
            "resolvedCount",
            resolvedCount ? resolvedCount.recordCount : 0
          );
          sessionStorage.setItem(
            "declinedCount",
            declinedCount ? declinedCount.recordCount : 0
          );
        },
        (err) => {
          console.error(err);
        }
      );
  }

  getAvailableIssues() {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(
          `${this.apiUrl}/clinical-permissions-functions/authorized-issues`,
          { headers: headers }
        )
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            console.error("Failed to load data.", err);
            this.decreaseSpinnerCount();
            observer.next([]);
            observer.complete();
          }
        );
    });

    // return this.http.get(`${this.dataUrl}/cp/goals_interventions`,
    //   { headers: headers, params: params });
  }

  getAvailableSections() {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(
          `${this.apiUrl}/clinical-permissions-functions/authorized-sections`,
          { headers: headers }
        )
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            console.error("Failed to load data.", err);
            this.decreaseSpinnerCount();
            observer.next([]);
            observer.complete();
          }
        );
    });
  }

  getGoalsAndInterventions(sectionTypeCode: string, issueTypeCode: string) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    let params = new HttpParams()
      .set("sectionTypeCode", sectionTypeCode)
      .set("issueTypeCode", issueTypeCode);

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/cp/goals_interventions`, {
          headers: headers,
          params: params,
        })
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.get(`${this.dataUrl}/cp/goals_interventions`,
    //   { headers: headers, params: params });
  }

  getLookups(lookupType: string) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    let params = new HttpParams().set("lookup_type", lookupType);

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/lookup`, { headers: headers, params: params })
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.get(`${this.dataUrl}/lookup`,
    //   { headers: headers, params: params });
  }

  getPatientBriefData() {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/cp/patients/${this.patChartId}/profiles`, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.get(`${this.dataUrl}/cp/patients/${this.patChartId}/assessments/${this.assessmentId}/profiles`,
    //   { headers: headers });
  }

  getTimezone() {
    if (sessionStorage["patChartId_timezone"] !== this.patChartId) {
      if (+this.assessmentId) {
        let headers = new HttpHeaders().set("Content-Type", "application/json");

        this.http
          .get(
            `${this.dataUrl}/cp/patients/${this.patChartId}/assessments/${this.assessmentId}/time_zone`,
            { headers: headers }
          )
          .subscribe(
            (data) => {
              sessionStorage.setItem("orgTimeZone", data["orgTimeZone"]);
              sessionStorage.setItem(
                "patCareLocTimeZone",
                data["patientCareLocationTimeZone"]
              );

              sessionStorage["patChartId_timezone"] = this.patChartId;
            },
            (err) => {
              console.error(err);
            }
          );
      } else {
        console.warn("Called getTimezone without an assessmentId");
      }
    }
  }

  // POST CALLS
  // ----------------------------------

  addGoalAndIntervention(
    issueId: string,
    data: {
      title: string;
      interventions: Array<{ title: string; assignedName: Array<string> }>;
    }
  ) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .post(`${this.dataUrl}/cp/issues/${issueId}/goals`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully saved record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to saved record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.post(`${this.dataUrl}/cp/issues/${issueId}/goals`, data,
    //   { headers: headers });
  }

  addIntervention(
    goalId: string,
    data: {
      interventions: Array<{ title: string; assignedName: Array<string> }>;
    }
  ) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .post(`${this.dataUrl}/cp/goals/${goalId}/interventions`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully saved record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to saved record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.post(`${this.dataUrl}/cp/goals/${goalId}/interventions`, data,
    //   { headers: headers });
  }

  getIssueUpdated() {
    return this.issueUpdatedSubject.asObservable();
  }

  addIssue(patChartId: string, data: object): any {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .post(`${this.dataUrl}/cp/issue/${patChartId}`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully saved record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
            this.issueUpdatedSubject.next(data);
          },
          (err) => {
            this.presentErrorToast(err, "Failed to saved record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.post(`${this.dataUrl}/cp/issues/${issueId}/goals`, data,
    //   { headers: headers });
  }

  addTask(patChartId: string, data: object) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .post(`${this.dataUrl}/cp/task/${patChartId}`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully saved record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
            this.issueUpdatedSubject.next(data);
          },
          (err) => {
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  // PUT CALLS
  // ----------------------------------

  //Accept, Decline, Resolve Issue
  updateIssueStatus(
    issueId: string,
    data: {
      lastStatusLookupCode: string;
      reasonLookupCode?: string;
      reason?: string;
    },
    endDate = ""
  ) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .put(
          `${this.dataUrl}/cp/issue_status/${issueId}?end_date=${endDate}`,
          data,
          { headers: headers }
        )
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully updated record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to update record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.put(`${this.dataUrl}/cp/issue_status/${issueId}`, data,
    //   { headers: headers });
  }

  //Meet, Discontinue Goal
  updateGoalStatus(
    goalId: string,
    data: { lastStatusLookupCode: string; reason?: string }
  ) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      this.http
        .put(`${this.dataUrl}/cp/goal_status/${goalId}`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully updated record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to update record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.put(`${this.dataUrl}/cp/goal_status/${goalId}`, data,
    //   { headers: headers });
  }

  //Discontinue Intervention
  updateInterventionStatus(
    interventionId: string,
    data: { lastStatusLookupCode: string; reason?: string }
  ) {
    let headers = new HttpHeaders().set("Content-Type", "application/json");

    return new Observable((observer) => {
      this.increaseSpinnerCount("Updating Record...");
      return this.http
        .put(`${this.dataUrl}/cp/intervention_status/${interventionId}`, data, {
          headers: headers,
        })
        .subscribe(
          (data) => {
            this.presentSuccessToast("Successfully updated record data.");
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to update record.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });

    // return this.http.put(`${this.dataUrl}/cp/intervention_status/${interventionId}`, data,
    //   { headers: headers });
  }

  presentSuccessToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "success",
    });

    toast.present();
  }

  presentErrorToast(err: HttpErrorResponse, message: string) {
    if (err && (err as any).code === "REFRESH_TOKEN_FAILED") {
      return;
    }
    message += " ";
    // console.log( "Data service error: ", err.error );
    if (err.error instanceof Error) {
      message += "Client error.";
    } else {
      message += " ";
      if (err.status == 401) {
        message += "User not authorized.";
      } else if (err.status >= 500) {
        message += "Server error.";
      } else {
        message += "Communication error.";
      }
    }

    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }

  increaseSpinnerCount(message: string = "Loading data...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  decreaseSpinnerCount() {
    // console.log( "Decreasing spinner count.", this.spinnerCounter );
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }

  assignIssuesPermissions(
    availableIssues: any[],
    availableSections: any[],
    issues: any
  ) {
    availableIssues = availableIssues || [];
    // Extracting issue type lookup codes from available issues
    const availableIssuesLookups = availableIssues.map(
      (i) => i["issueTypeLookupCode"]
    );
    const availableIssueSections = availableSections.map(
      (i) => i["sectionTypeLookupCode"]
    );
    // Updating permissions for each issue
    issues.issues = issues.issues.map((issue) => {
      // Checking if the issue type is in the list of available issues
      if (issue.issueTypeLookupCode) {
        issue.access = availableIssuesLookups.includes(
          issue.issueTypeLookupCode
        )
          ? "write"
          : "read";
      } else {
        // We don't have an issue type, so it must be "other"... Check their section access
        issue.access = availableIssueSections.includes(
          issue.sectionTypeLookupCode
        )
          ? "write"
          : "read";
      }
      // Updating permissions for goals and interventions within each issue
      issue.goals = issue.goals.map((goal) => {
        goal.access = issue.access;
        goal.interventions = goal.interventions.map((intervention) => {
          intervention.access = issue.access;
          return intervention;
        });
        return goal;
      });
      return issue;
    });
    return issues;
  }

  getIssuesWithPermissions(issueStatusType: string, patientChartId?: string) {
    return new Observable((observer) => {
      forkJoin([
        this.getAvailableIssues(),
        this.getAvailableSections(),
        this.getIssues(issueStatusType, patientChartId),
      ]).subscribe(
        ([availableIssues, availableSections, issues]: [any[], any[], any]) => {
          if (+this.assessmentId) {
            observer.next(issues);
          } else {
            observer.next(
              this.assignIssuesPermissions(
                availableIssues,
                availableSections,
                issues
              )
            );
          }
          observer.complete();
        },
        (error) => {
          console.error(error);
          observer.complete();
        }
      );
    });
  }

  faxCarePlan(faxData: any): Observable<any> {
    const url = `${this.dataUrl}/cp/fax`;
    return this.http.post(url, faxData);
  }
}



// WEBPACK FOOTER //
// ./src/providers/poc-data-service/poc-data-service.ts